// @ts-nocheck
/* eslint-disable */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.typography = void 0;

var _colors = require('./colors.theme');

var typography = {
  defaultFontFamily: 'Overpass',
  defaultColors: {
    withLightBg: _colors.colors.primaryFont,
    withDarkBg: _colors.colors.white
  },
  baseFontSize: {
    xxs: '16px',
    xs: '18px',
    sm: '20px',
    md: '20px',
    lg: '22px',
    xl: '24px'
  },
  text: {
    normal: {
      fontSize: {
        xxs: '1rem'
      },
      lineHeight: {
        xxs: '1.5em'
      }
    },
    small: {
      fontSize: {
        xxs: '.869rem',
        xs: '.833rem'
      },
      lineHeight: {
        xxs: '1.2em'
      }
    },
    xSmall: {
      fontSize: {
        xxs: '.756rem',
        xs: '.694rem'
      },
      lineHeight: {
        xxs: '1.2em'
      }
    },
    xxSmall: {
      fontSize: {
        xxs: '.657rem',
        xs: '.578rem'
      },
      lineHeight: {
        xxs: '1.2em'
      }
    }
  },
  heading: {
    h1: {
      fontSize: {
        xxs: '2.3130607656rem',
        xs: '2.985984rem'
      },
      lineHeight: {
        xxs: '1.2em'
      }
    },
    h2: {
      fontSize: {
        xxs: '2.0113571875rem',
        xs: '2.48832rem'
      },
      lineHeight: {
        xxs: '1.2em'
      }
    },
    h3: {
      fontSize: {
        xxs: '1.74900625rem',
        xs: '2.0736rem'
      },
      lineHeight: {
        xxs: '1.2em'
      }
    },
    h4: {
      fontSize: {
        xxs: '1.520875rem',
        xs: '1.728rem'
      },
      lineHeight: {
        xxs: '1.2em'
      }
    },
    h5: {
      fontSize: {
        xxs: '1.3225rem',
        xs: '1.44rem'
      },
      lineHeight: {
        xxs: '1.2em'
      }
    },
    h6: {
      fontSize: {
        xxs: '1.15rem',
        xs: '1.2rem'
      },
      lineHeight: {
        xxs: '1.2em'
      }
    }
  }
};
exports.typography = typography;
